import SectionHeading from '@/components/base/SectionHeading';
import Reveal from '@/components/feature/Reveal';
import { deliverables } from '@/mocks/deliverables';

export default function Deliverables() {
  return (
    <section className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-8">
        <div className="max-w-shell mx-auto">
          <Reveal>
            <SectionHeading
              eyebrow="What you get"
              title="Everything you need, at zero cost"
              subtitle="The EA is free, and so is everything around it. No license fee, no subscription, no profit-sharing — ever."
            />
          </Reveal>

          <div className="mt-10 md:mt-12 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
            {deliverables.map((item, index) => (
              <Reveal key={item.id} delay={index * 70}>
                <div className="h-full rounded-lg border border-background-200 bg-background-50 p-5 md:p-6 hover:border-accent-300 transition-colors duration-200">
                  <span className="w-12 h-12 flex items-center justify-center rounded-lg bg-accent-100 text-accent-800">
                    <i className={`${item.icon} text-2xl`} aria-hidden="true"></i>
                  </span>
                  <h3 className="mt-4 font-heading text-sm md:text-base font-semibold text-foreground-950">
                    {item.title}
                  </h3>
                  <p className="mt-2 text-xs md:text-sm leading-relaxed text-foreground-600">{item.text}</p>
                </div>
              </Reveal>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}